import { useLocalization } from "@fluent/react";
import { Button, Row } from "@narmi/design_system";
import { Dialog } from "cerulean";

type LeavePageDialogProps = {
  isOpen: boolean;
  unsentCount: number;
  onLeave: () => void;
  onStay: () => void;
};

const LeavePageDialog = ({
  isOpen,
  unsentCount,
  onLeave,
  onStay,
}: LeavePageDialogProps) => {
  const { l10n } = useLocalization();
  const body = () => {
    if (unsentCount === 0) return l10n.getString("live-ledger-leave-body-none");
    if (unsentCount === 1) {
      return l10n.getString("live-ledger-leave-body-single");
    }
    return l10n.getString("live-ledger-leave-body", { count: unsentCount });
  };

  return (
    <Dialog
      isOpen={isOpen}
      title={l10n.getString("live-ledger-leave-title")}
      onUserDismiss={onStay}
      testId="live-ledger-leave-dialog"
      footer={
        <Row alignItems="center" justifyContent="end" gapSize="s">
          <Row.Item shrink>
            <Button
              kind="secondary"
              label={l10n.getString("live-ledger-leave-confirm")}
              onClick={onLeave}
              testId="live-ledger-leave-confirm"
            />
          </Row.Item>
          <Row.Item shrink>
            <Button
              kind="primary"
              label={l10n.getString("live-ledger-leave-stay")}
              onClick={onStay}
              testId="live-ledger-leave-stay"
            />
          </Row.Item>
        </Row>
      }
    >
      <p className="fontColor--primary">{body()}</p>
    </Dialog>
  );
};

export default LeavePageDialog;
